<template>
  <div>
    <subscription-modal ref="subscription" :subscriptions="subscriptions" :subscription-id="selectedSubscriptionId" :show.sync="showSubscriptionModal"></subscription-modal>

    <loading v-model="loading" :height="300">
      <div class="table-fix-head table-height-300">
        <table class="table table-light">
          <thead>
            <tr>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('checkbox')">
                <b-form-checkbox v-bind="checkbox$header" @change="checkbox$toggle"/>
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('id')">
                Részletek
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('customer')">
                Ügyfél
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('package')">
                Csomag
              </th>
              <th scope="col" class="p-2 pb-3" v-if="!table$hiddenColumns.has('state')">
                Állapot
              </th>
              <th scope="col" class="p-2 pb-3">
                Időpont
              </th>
              <th scope="col" class="p-2 pb-3 text-right">
                <list-actions :actions="actions" :processing="processing" :selection="checkbox$selection"></list-actions>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(subscription, index) in subscriptions"
              :key="`p${index}`"
            >
              <td class="p-2" v-if="!table$hiddenColumns.has('checkbox')">
                <b-form-checkbox
                  v-model="checkbox$selection"
                  :value="subscription.id"
                />
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('id')">
                <span class="badge badge-secondary">#{{ subscription.id }}</span>
                <b-button variant="link" @click="selectedSubscriptionId = subscription.id">Előfizetés</b-button>
                <span class="badge badge-success" v-if="subscription.is_trial">Próbaidőszak</span>
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('customer')">
                <span v-if="subscription.customer">{{ subscription.customer.name }}</span>
                <span v-if="!subscription.customer">Törölt ügyfél</span>
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('package')">
                <span v-if="subscription.package">{{ subscription.package.name }}</span>
                <span v-if="!subscription.package">Töröl csomag</span>
              </td>
              <td class="p-2" v-if="!table$hiddenColumns.has('state')">
                <span :class="`badge badge-${getSubscriptionState(subscription.state).variant}`">{{ getSubscriptionState(subscription.state).text }}</span>
              </td>
              <td class="p-2" colspan="2">
                <div class="small">Előfizetés vége: {{ displayFormatDate(subscription.schedule_end) }}</div>
                <div class="small">Következő fizetés esedékes: {{ displayFormatDate(subscription.schedule_next_payment) }}</div>
                <div class="small" v-if="subscription.is_trial">Próbaidőszak vége: {{ displayFormatDate(subscription.schedule_end_trial) }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-right mt-3" v-if="!table$hiddenColumns.has('checkbox')">
        {{ checkbox$selection.length }} elem kiválasztva
      </div>
    </loading>
  </div>
</template>
<style lang="scss">
</style>
<script>
import moment from 'moment'
import Loading from '../common/LoadingPlaceholder'
import { displayFormatDate } from '../../utils/Date'
import CheckboxHelper from '../../utils/mixins/CheckboxHelper'
import { getSubscriptionState } from './_subscription'
import TableHelper from '../../utils/mixins/TableHelper'
import ListActions from '../common/ListActions'


export default {
  mixins: [
    CheckboxHelper('subscriptions'),
    TableHelper('subscriptions', 'id', {
      subscriptionState: {
        type: String,
        required: false,
        default: '',
        key: 'state'
      }
    }, 'api.billing-subscriptions.index')
  ],
  components: {
    'loading': Loading,
    'list-actions': ListActions
  },
  props: {
    actions: {
      type: Array,
      default: () => ([]),
      required: false
    },
    processing: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      showModal: false,
      selectedSubscriptionId: -1,
      loading: true,
      subscriptions: [],
    }
  },
  computed: {
    showSubscriptionModal: {
      get() {
        return this.selectedSubscriptionId !== -1
      },
      set(shown) {
        if(!shown) {
          this.selectedSubscriptionId = -1
        }
      }
    },
  },
  mounted() {
  },
  methods: {
    subscriptionsUpdated({subscriptions}) {
      _.forEach(subscriptions, subscription  => {
        this.subscriptions = _.filter(this.subscriptions, currentSubscription => currentSubscription.id !== subscription.id)

        if(this.subscriptionState.length > 0 && subscription.state === this.subscriptionState) {
          this.subscriptions.push(subscription)
        }
      })

    },
    displayFormatDate,
    getSubscriptionState
  }
}
</script>